import { legitReducers } from 'apex-legit-service'
import { apexMenuReducers } from 'apex-online-menu'
import {
  ApexAccounts,
  ApexAuth,
  ApexCash,
  ApexProviders,
} from 'apex-ui-services'
import { combineReducers, Reducer } from 'redux'
import {
  accountDetailsReducer,
  accountOwnersReducer,
  accountsReducer,
  assetsReducer,
  auditTrailReducer,
  caseReducer,
  correspondentReducer,
  documentsReducer,
  marginDetailsReducer,
  transferDetailsReducer,
  transfersReducer,
} from '../reducers'

export const rootReducer = combineReducers({
  ...ApexCash.achRel.reducers,
  ...ApexCash.amountAvailable.reducers,
  ...ApexCash.achTransfers.reducers,
  ...ApexAccounts.accounts.reducers,
  ...ApexCash.iraConstraints.reducers,
  ...ApexCash.transfers.reducers,
  ...ApexAuth.authorization.reducers,
  ...ApexAuth.loginSso.reducers,
  ...ApexAuth.loginType.reducers,
  ...(legitReducers as Record<string, Reducer>),
  ...ApexProviders.margins.reducers,
  ...(apexMenuReducers as Record<string, Reducer>),
  accountDetailsReducer,
  accountOwnersReducer,
  accountsReducer,
  assetsReducer,
  auditTrailReducer,
  caseReducer,
  correspondentReducer,
  documentsReducer,
  marginDetailsReducer,
  transferDetailsReducer,
  transfersReducer,
})

export default rootReducer
